export default {
    title: "分行/子公司管理",
    table1: "編號",
    table2: "母公司",
    table3: "分行/子公司名稱",
    table4: "聯繫電話",
    table5: "電子郵箱",
    table6: "傳真",
    table7: "聯絡人",
    table8: "操作",
    isDel: "是否刪除當前分行/子公司？",
    addTitle: "添加分行/子公司",
    form1: "所屬母公司：",
    form2: "分行/子公司編號：",
    form3: "名稱（中）：",
    form4: "名稱（英）：",
    form5: "聯繫人：",
    form6: "電話：",
    form7: "郵箱：",
    form8: "地址：",
    form9: "傳真：",
    form10: "分配金額：",
    rule1: "請選擇所屬分行",
    rule2: "請輸入分行/子公司編號",
    rule3: "請輸入名稱（中）",
    rule4: "請輸入名稱（英）",
    rule5: "請輸入聯繫人",
    rule6: "請輸入電話",
    rule7: "請輸入郵箱",
    rule8: "請輸入地址",
    rule9: "請輸入傳真",
    diaTitle: "編輯修改",
    errmsg: "您的分配金額已超過可分配額度，請重新輸入！",
}